import { Controller } from "stimulus"

export default class extends Controller {

  connect() {
    this.update_weather_info()
  }

  update_weather_info() {
    var that = this
    let request_url = this.get_request_url("7:00")
    this.request_data(request_url, function (response) {
      that.time_1.value = "07:00"
      if (!that.weather_1.value)
        that.weather_1.value = response.data[0].weather[0].description
      if (!that.temperature_1.value)
        that.temperature_1.value = Math.round(response.data[0].temp * 10) / 10 + " °C"
      if (!that.precipitation_1.value && response.data[0].rain) {
        that.precipitation_1.value = Object.values(response.data[0].rain).reduce((a, b) => a + b, 0) + " mm/h"
      }
      if (!that.wind_speed_1.value)
        that.wind_speed_1.value = Math.round(response.data[0].wind_speed * 10) / 10 + " m/s"
    })

    request_url = this.get_request_url("12:00")
    this.request_data(request_url, function (response) {
      that.time_2.value = "12:00"
      if (!that.weather_2.value)
        that.weather_2.value = response.data[0].weather[0].description
      if (!that.temperature_2.value)
        that.temperature_2.value = Math.round(response.data[0].temp * 10) / 10 + " °C"
      if (!that.precipitation_2.value && response.data[0].rain) {
        that.precipitation_2.value = Object.values(response.data[0].rain).reduce((a, b) => a + b, 0) + " mm/h"
      }
      if (!that.wind_speed_2.value)
        that.wind_speed_2.value = Math.round(response.data[0].wind_speed * 10) / 10 + " m/s"
    })

    request_url = this.get_request_url("15:00")
    this.request_data(request_url, function (response) {   
      that.time_3.value = "15:00"
      if (!that.weather_3.value)
        that.weather_3.value = response.data[0].weather[0].description
      if (!that.temperature_3.value)
        that.temperature_3.value = Math.round(response.data[0].temp * 10) / 10 + " °C"
      if (!that.precipitation_3.value && response.data[0].rain) {
        that.precipitation_3.value = Object.values(response.data[0].rain).reduce((a, b) => a + b, 0) + " mm/h"
      }
      if (!that.wind_speed_3.value)
        that.wind_speed_3.value = Math.round(response.data[0].wind_speed * 10) / 10 + " m/s"
    })
  }

  get_request_url(value) {
    let time = new Date(`${this.current_date.replace(/-/g, '/')} ${value}`)
    time = time.getTime() / 1000
    return `https://api.openweathermap.org/data/3.0/onecall/timemachine?lat=${this.latitude}&lon=${this.longitude}&dt=${time}&units=metric&lang=sl&appid=${this.api_key}`
  }

  get api_key() {
    return "dcce609061f4e86453f230123350b14f"
  }

  get current_date() {
    return this.data.get("currentDate")
  }

  get latitude() {
    return this.data.get("latitude")
  }

  get longitude() {
    return this.data.get("longitude")
  }

  get time_1() {
    return this.targets.find('time_1')
  }

  get weather_1() {
    return this.targets.find('weather_1')
  }

  get temperature_1() {
    return this.targets.find('temperature_1')
  }

  get precipitation_1() {
    return this.targets.find('precipitation_1')
  }

  get wind_speed_1() {
    return this.targets.find('wind_speed_1')
  }

  get time_2() {
    return this.targets.find('time_2')
  }

  get weather_2() {
    return this.targets.find('weather_2')
  }

  get temperature_2() {
    return this.targets.find('temperature_2')
  }

  get precipitation_2() {
    return this.targets.find('precipitation_2')
  }

  get wind_speed_2() {
    return this.targets.find('wind_speed_2')
  }

  get time_3() {
    return this.targets.find('time_3')
  }

  get weather_3() {
    return this.targets.find('weather_3')
  }

  get temperature_3() {
    return this.targets.find('temperature_3')
  }

  get precipitation_3() {
    return this.targets.find('precipitation_3')
  }

  get wind_speed_3() {
    return this.targets.find('wind_speed_3')
  }



  request_data(url, callback) {
    $.ajax({
      type: 'GET',
      contentType: 'application/json',
      dataType: 'jsonp',
      url: url,
      success: callback,
      error: function (response) { }
    })
  }
}
